<form [formGroup]="criticalHealthForm">

    <div class="modal-header modalHeaderBlack">
        <h6 class="modal-title">{{"RegistrationPage.criticalHealthInfo" | translate}}</h6>
        <span aria-label="Close" class="close" (click)="onNoClick()" matTooltip="{{ 'inventory.close' | translate }}"
            data-automation-attribute="span-close-dialog">
            <mat-icon>clear</mat-icon>
        </span>
    </div>

    <div class="modal-body bodyCreatePasscode">

        <mat-grid-list cols="6" rowHeight="60px">

            <!-- Condition Type -->
            <mat-grid-tile [colspan]="3">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{"RegistrationPage.conditionType" | translate}}</mat-label>
                    <mat-select formControlName="conditionType">
                        <mat-option *ngFor="let item of conditionTypeMasterList" [value]="item">
                            {{ item.desc }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- Date of Entry -->
            <mat-grid-tile [colspan]="3" *ngIf="this.data.isUpdate || this.data.isViewOnly">
                <div class="float-wrapper">
                    <label class="float-label"
                        [class.float]="isFocus || criticalHealthForm.controls['dateOfEntry'].value">
                        {{"RegistrationPage.dateOfEntry" | translate}}
                    </label>

                    <ejs-datetimepicker formControlName="dateOfEntry" (focus)="isFocus = true" (blur)="isFocus = false"
                        placeholder="" format="dd/MM/yyyy hh:mm a" [step]="1" [cssClass]='cssClass' [readonly]="this.data.isUpdate">
                    </ejs-datetimepicker>
                </div>
            </mat-grid-tile>

        </mat-grid-list>

        <!-- Description -->
        <mat-grid-list cols="6">
            <mat-grid-tile [colspan]="6">
                <div class="custom-mat-field">
                    <textarea rows="6" class="custom-textarea" placeholder=" " formControlName="description"></textarea>
                    <label class="custom-label">{{"RegistrationPage.diseaseDesc" | translate}}</label>
                </div>
            </mat-grid-tile>
        </mat-grid-list>

    </div>

    <div class="bottom-div">
        <mat-grid-list cols="6" rowHeight="55px">

            <mat-grid-tile [colspan]="5"></mat-grid-tile>

            <mat-grid-tile [colspan]="1">
                <div class="div-custom">

                    <!-- Back Button -->
                    <button class="btnOrange" style="margin-right: 10px" mat-mini-fab matTooltip="Back"
                        (click)="onNoClick()">
                        <mat-icon>keyboard_arrow_left</mat-icon>
                    </button>

                    <!-- Save Button -->
                    <button matTooltip="Save" *ngIf="!data.isViewOnly" class="btnCyan" mat-mini-fab
                        style="margin-right: 10px" (click)="onSaveClick()">
                        <mat-icon>sim_card</mat-icon>
                    </button>

                </div>
            </mat-grid-tile>

        </mat-grid-list>
    </div>

</form>